<script setup lang="ts">
import { init as echartsInit } from 'echarts'
import { ref, onMounted } from 'vue'
import { getCommerceTrendApi } from '@/api/commerce'
import { dayjs } from 'element-plus'
import { commerceNameList } from '../data'

const props = defineProps<{ commerceId: number }>()

const chart = ref<HTMLElement>()
onMounted(async () => {
  const res = await getCommerceTrendApi({ commerceId: props.commerceId })
  res.reverse()
  const myChart = echartsInit(chart.value)
  window.onresize = myChart.resize
  const priceList = res.map((item) => item.price)
  myChart.setOption({
    grid: {
      left: '40px',
    },
    xAxis: {
      type: 'category',
      data: res.map((item) => dayjs(item.created).format('MM-DD HH:ss')),
    },
    yAxis: {
      type: 'value',
      min: Math.floor((Math.min(...priceList) - 200) / 100) * 100,
      max: Math.floor((Math.max(...priceList) + 200) / 100) * 100,
      splitLine: {
        lineStyle: { color: '#ffffff69' },
      },
    },
    series: [
      {
        data: priceList.map((item, index) => ({
          value: item,
          label: {
            show: true,
            position: 'top',
            color: priceList[index - 1] > item ? '#93ca76' : '#d3381c',
            fontWeight: 'bold',
          },
        })),
        type: 'line',
      },
    ],
  })
})
</script>

<template>
  <h2 class="affix" style="margin: 10px 0">
    <span :class="commerceNameList[commerceId]?.classes">{{ commerceNameList[commerceId]?.name }}</span>
  </h2>
  <div ref="chart" style="height: 50vh"></div>
</template>

<style lang="scss" scoped></style>
